import Modal from './Modal/Modal';
import './SignInModal/SignInModal.scss';
import { useEffect, useState } from 'react';
import { LoadingIndicator } from './cart';
import { observer } from 'mobx-react-lite';
import type { BookingsStore } from '@micro-apps/stores';
import FindReservationForm from './SignInModal/FindReservationForm/FindReservationForm';
import { analyticEvents } from '@micro-apps/shared';

const FindReservationModal = ({
	closeModal,
	bookingsStore,
	properties,
	property,
}: {
	closeModal: () => unknown;
	bookingsStore: BookingsStore;
	properties: any[];
	property: any;
}) => {
	const [isloading, setIsLoading] = useState(false);
	const [isError, setIsError] = useState(false);

	useEffect(() => {
		analyticEvents.findReservationFormShown();
	}, []);

	const handleReservationSubmit = async (reservationNumber, lastName, hotelCode) => {
		try {
			setIsLoading(true);
			await bookingsStore.findReservation(reservationNumber, lastName, hotelCode);
			analyticEvents.findReservationFormSubmitted();
			closeModal();
		} catch {
			setIsError(true);
			setIsLoading(false);
		}
	};

	return (
		<Modal close={closeModal}>
			<div className="form-wrapper">
				{isloading ? (
					<LoadingIndicator />
				) : (
					<FindReservationForm
						isError={isError}
						setIsError={setIsError}
						isPersistentlySignedIn={false}
						properties={properties}
						property={property}
						handleReservationSubmit={(reservationNumber, lastName, hotelCode) =>
							handleReservationSubmit(reservationNumber, lastName, hotelCode)
						}
					/>
				)}
			</div>
		</Modal>
	);
};

export default observer(FindReservationModal);
